<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="avatar" size="70px" class="mr-4 mb-4" />
      <div>
        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">

            <vs-button class="mr-4 mb-4" @click="$refs.updateImgInput.click()">Changer d'avatar</vs-button>
            <vs-button type="border" color="danger" @click="avatar = null">Supprimer l'avatar</vs-button>
      </div>
    </div>
    
    <!-- Info -->
    
    <vs-input class="w-full mb-base" label-placeholder="nom" v-model="name"></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="prenom" v-model="prenom"></vs-input>
    
    <vs-input class="w-full" label-placeholder="Email" v-model="email"></vs-input>

    
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end mt-5">
      <vs-button class="ml-auto mt-2"  @click="save_changes">Sauvegarder</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Réinitialiser</vs-button>
    </div>
  </vx-card>
</template>

<script>
import axios from "../../../http/axios/index.js"
import store from "../../../store/store.js"
export default {
  data() {
    return {
      //username: "johny_01",
      change_image:false,
      id: this.$store.state.AppActiveUser.id,
      name: this.$store.state.AppActiveUser.nom,
      prenom: this.$store.state.AppActiveUser.prenom,
      email: this.$store.state.AppActiveUser.email,
      password: this.$store.state.AppActiveUser.password,
      company: "SnowMash Technologies Pvt Ltd",
      avatar :this.$store.state.AppActiveUser.avatar,
    }
  },
  computed: {
    activeUserInfo() {
      //console.log('name',store.state.AppActiveUser.nom)
      console.log('rrr',this.$store.state.AppActiveUser)
      return this.$store.state.AppActiveUser
    },
  },
  
  methods: {
    updateCurrImg(input) {
      
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.avatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
      this.change_image = true
      console.log("this.change_image",this.change_image)

    },
    save_changes() {
      
      this.$store.state.AppActiveUser.nom = this.name
      this.$store.state.AppActiveUser.email= this.email
      this.$store.state.AppActiveUser.prenom= this.prenom
      this.$store.state.AppActiveUser.avatar= this.avatar
      
      axios.post("https://trainingcenterback.codily.net/api/updateFormateur/"+this.id, {
        
        nom: this.name,
        prenom: this.prenom,
        email: this.email,
        mobile: this.$store.state.AppActiveUser.mobile,
        adresse: this.$store.state.AppActiveUser.adresse,
        password: this.$store.state.AppActiveUser.password,
        

      } ).then((response) => {
          console.log("admins",response.data)
          
          const payload={
            email: response.data.email,
            nom: response.data.nom,
            prenom: response.data.prenom,
            
          }
        this.$store.dispatch('auth/updateauth', payload)
        })
      
      
      console.log(this.$store.state.AppActiveUser)
      if(this.change_image){
      axios.post("https://trainingcenterback.codily.net/api/update_avatar_Formateur/"+this.id, {
        avatar: this.avatar,
      } ).then((response) => {
          console.log("admins",response.data)
          
          const payload={
            avatar: response.data.avatar,
            
            
          }
        this.$store.dispatch('auth/updateauth', payload)
        })
      }
        this.showMessage('success', 'update', 'successfully update') 
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'compte '+title,
                text: 'The compte was '+text
              })
            },
    reset_data() {
      this.name = this.$store.state.AppActiveUser.nom;
      this.prenom = this.$store.state.AppActiveUser.prenom;
      this.email = this.$store.state.AppActiveUser.email;

    },
    /**this.$store.dispatch("candidat/updateavatarRecord", this.data_local).then(()   => { this.$store.dispatch("candidat/fetchUsers").catch(err => { console.error(err) }); this.$forceUpdate(); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('success', 'update', 'successfully update avatar') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not update', 'an error in update: '+ err) }) 
       console.log("avatar change")
       }
      
    },*/
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'compte '+title,
                text: 'The compte was '+text
              })
            },
    update_avatar() {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  },
}
</script>
